import styled from 'styled-components';

import { Checkbox } from '@xemplo/checkbox';
import { DawnTick } from '@xemplo/icons';

export const SelectedTick = styled(DawnTick)`
  margin-left: auto;
  flex-shrink: 0;
`;

export const CustomCheckbox = styled(Checkbox)`
  margin-left: auto;
`;
